import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import Loader from "./components/Loader";
const Navbar = lazy(() => import("./components/Navbar"));
const Footer = lazy(() => import("./components/Footer"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const FAQ = lazy(() => import("./pages/FAQ"));
const PaperCalculation = lazy(() => import("./pages/PaperCalculation"));
const BoardPaperSize = lazy(() => import("./pages/BoardPaperSize"));
const Contact = lazy(() => import("./pages/Contact"));
const Enquiry = lazy(() => import("./pages/Enquiry"));
const Products = lazy(() => import("./pages/Products"));
const Calculator = lazy(() => import("./pages/Calculator"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Terms = lazy(() => import("./pages/Terms"));
const Shipping = lazy(() => import("./pages/Shipping"));
const Refund = lazy(() => import("./pages/Refund"));
const JTLChatbot = lazy(() => import("./components/JTLChatbot"));


function PageWrapper({ children }) {
  const location = useLocation();
  
  useEffect(() => {
    // Re-trigger AOS on route change
    AOS.refresh();
  }, [location.pathname]);

  return (
    <div key={location.pathname} className="page-animate overflow-x-hidden w-full">
      {children}
    </div>
  );
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false, // animate every time you scroll up and down
      mirror: true,
      offset: 50,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <Suspense fallback={<Loader/>}>
      <Router>
        <Navbar />
        <ScrollToTop />
        <PageWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route
              path="/paper-facts/paper-calculation"
              element={<PaperCalculation />}
            />
            <Route
              path="/paper-facts/board-paper-size"
              element={<BoardPaperSize />}
            />
            <Route
              path="/paper-facts/calculator"
              element={<Calculator />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/products" element={<Products />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/refund" element={<Refund />} />
          </Routes>
        </PageWrapper>
        <Footer />
        <JTLChatbot />
      </Router>
    </Suspense>
  );
}
export default App;
